module.exports = __webpack_public_path__ + "static/andrea-e7e4fd4e449aa6a5f611f74c8689272f.png";